// extracted by mini-css-extract-plugin
export default {"tooltipStyle":"BasicTooltip_tooltipStyle__UPXAo"};